import React from 'react'

export default function Button(props) {
  return (
    <div style={props.style} className={`button button-${props.type}`} onClick={props.onClick} disabled={props.disabled}>
      <p className={`button-text button-text-${props.type}`}>{props.title}</p>
    </div>
  )
}